import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import type { LoadingStatusCode } from "../../lib/types";
import buildUrl from "../../lib/utils/buildUrl";
import { baseUrl } from "../../lib/routes/baseUrl";
import { catchApiError } from "../../lib/utils/catchApiError";

export interface ITaxShort {
  gross: string;
  net: string;
  tax: string;
  taxRate: string;
}

export interface ITaxShortParams {
  serviceTypeId: number;
  amount: number;
  amountType: "NET" | "GROSS";
  onDate: string;
}

interface InitialState {
  tax?: ITaxShort;
  taxLoading: LoadingStatusCode;
}

const initialState: InitialState = {
  taxLoading: "idle",
};

export const fetchTax = createAsyncThunk<ITaxShort, ITaxShortParams>(
  "taxTs/fetchTax",
  async (params) => {
    try {
      const url = buildUrl({
        url: [baseUrl, "offerings-api", "taxes", "short"].join("/"),
        searchParams: {
          ...params,
        },
      });
      const { data } = await axios.get<ITaxShort>(url);
      return data;
    } catch (e) {
      return catchApiError({
        e,
        title: "Ошибка загрузки ставки налога. Попробуйте позже",
      });
    }
  }
);

const slice = createSlice({
  name: "tax",
  initialState,
  reducers: {
    cleanTax: (state) => {
      state.taxLoading = "idle";
      state.tax = undefined;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchTax.pending, (state) => {
        state.taxLoading = "pending";
      })
      .addCase(fetchTax.rejected, (state) => {
        state.taxLoading = "rejected";
        state.tax = undefined;
      })
      .addCase(fetchTax.fulfilled, (state, { payload }) => {
        state.taxLoading = "rejected";
        state.tax = payload;
      });
  },
});

export const { reducer: taxTsReducer, actions: taxTsActions } = slice;
